const CLIPS = [
  { src: "/media/range-a.mp4", poster: "/media/range-a-poster.jpg", label: "Live-fire coaching", testid: "video-a" },
  { src: "/media/range-b.mp4", poster: "/media/range-b-poster.jpg", label: "Range day · Small cohort", testid: "video-b" },
];

export default function LiveFire({ code = "007" }) {
  return (
    <section className="border-y border-white/10 bg-black section-pad" data-testid="training-in-action">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-8 mb-14 items-end">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-4">// {code} — LIVE FIRE</div>
            <h2 className="font-heading text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Training in action.<br/><span className="text-[#FFD300]">No stock footage.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-neutral-400 leading-relaxed text-lg">
              Actual clips from SEP range sessions. Direct one-on-one coaching, live-fire
              technique correction, and the small-cohort learning environment every student walks into.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {CLIPS.map((v) => (
            <div key={v.testid} className="relative bg-[#0A0A0A] border border-white/10 hover:border-[#FFD300] transition-colors overflow-hidden group" data-testid={v.testid}>
              <video src={v.src} poster={v.poster} autoPlay loop muted playsInline preload="metadata" className="w-full aspect-[3/4] object-cover block" />
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/90 via-black/40 to-transparent pointer-events-none">
                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#FFD300]">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#FFD300] mr-2 animate-pulse" aria-hidden />
                  {v.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
